module.exports = __webpack_public_path__ + "static/media/ic-edit.00e4192f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/EquipmentListItem/ic-edit.svg
// module id = 1064
// module chunks = 0